export function addCurrent(patrimonysubgroup) {
    return {
        type: 'ADD_CURRENT',
        patrimonysubgroup,
    }
}
